__turbopack_context__.v({
  "profileDropdownContent": "userProfileMenuTemplate-module-scss-module__PmS9RW__profileDropdownContent",
});
